module.exports = __webpack_public_path__ + "static/media/workVan_salmon.164ed4e7.svg";